import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  type AuthState,
  type User,
  initialAuthState,
  setAuthLoading,
  setLoginSuccess,
  setTokenRefreshed,
  setAuthError,
  setLogout,
  updateUser,
  clearAuthError,
} from '@callbridge/ui';

interface AuthActions {
  startLoading: () => void;
  loginSuccess: (user: User, accessToken: string, refreshToken: string) => void;
  tokenRefreshed: (accessToken: string, refreshToken: string) => void;
  authError: (error: string) => void;
  logout: () => void;
  userUpdated: (updates: Partial<User>) => void;
  errorCleared: () => void;
}

export type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      ...initialAuthState,

      startLoading: () => set((s) => setAuthLoading(s)),
      loginSuccess: (user, at, rt) => set((s) => setLoginSuccess(s, user, at, rt)),
      tokenRefreshed: (at, rt) => set((s) => setTokenRefreshed(s, at, rt)),
      authError: (err) => set((s) => setAuthError(s, err)),
      logout: () => set(() => setLogout()),
      userUpdated: (updates) => set((s) => updateUser(s, updates)),
      errorCleared: () => set((s) => clearAuthError(s)),
    }),
    {
      name: 'cb_auth',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
